import React from 'react'
import ProcessorModal from '.'

export default function RequestCanceledModal({ open = false, onClose = () => {}, onSubmit = () => {} }) {
  return (
    <ProcessorModal open={open} onClose={onClose}>
      <div style={{ padding: '36px 60px 24px 60px', background: 'white', borderRadius: 6 }}>
        <div style={{ width: 380 }} className="dome-d-flex dome-flex-column dome-gap24">
          <span className="dome-h2 dome-color-red-alert">request canceled</span>
          <span className="dome-p2 dome-color-darkest-grey">
            This request is no longer active. It’s now located in the Canceled tab on your Questionnaires dashboard.
          </span>
          <div className="dome-d-flex dome-justify-between">
            <button
              type="button"
              onClick={onClose}
              className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
            >
              close
            </button>
            <button type="button" onClick={onSubmit} className="dome-btn dome-btn-base dome-btn-grey-stroke">
              back to dashboard
            </button>
          </div>
        </div>
      </div>
    </ProcessorModal>
  )
}
